import { Fragment, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import NavbarDashboard from "components/organism/Navbar/NavbarDashboard";

const Dashboard = () => {
    const token = window.localStorage.getItem("token");

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate("/auth/signin", { replace: true });
            toast.error("Sign in first to access");
        }
    }, [token]);

    const LogoutHandler = async () => {
        setLoading(true);
        try {
            setTimeout(() => {
                window.localStorage.removeItem("token");
                setLoading(false);
            }, 3000);

            toast.success("Log Out Successfully");
            navigate("/");
        } catch (error) {
            console.log(error);
            setLoading(false);

            toast.error("Log Out Failed");
        }
    };

    return (
        <Fragment>
            <NavbarDashboard />
            <div className="w-full mt-5 px-6 tablet:px-8 desktop:px-[120px]">
                <h1 className="font-semibold text-2xl text-neutral-100">Dashboard Page</h1>
                <p className="text-sm font-normal text-neutral-600 mt-2">You now are in the dashboard page</p>

                <button onClick={LogoutHandler} className="w-fit py-3 px-6 rounded-lg bg-semantic-danger-main text-neutral-10 font-semibold text-sm mt-5">{loading ? "Loading..." : "Logout"}</button>
            </div>
        </Fragment>
    );
};

export default Dashboard;